import styled from 'styled-components';

import { colors } from 'global/colors';

export const CardContainer = styled.div`
  position: relative;
  background: ${colors.white};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  max-width: 576px;
  height: ${(props) => (props.hasImage ? '315px' : 'auto')};
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.25s ease-in-out;
  backface-visibility: hidden;
  transform: scale(1);
  overflow: hidden;

  :hover {
    transform: scale(1.02);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
    animation-fill-mode: forwards;
  }
`;

export const Image = styled.div`
  position: relative;
  width: 100%;
  height: 150px;
  background-image: url(${(props) => props.image || ''});
  background-size: cover;
  background-position: center center;
`;

export const AnchorLink = styled.a`
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  color: ${colors.white};

  :hover {
    color: ${colors.green};
    text-decoration: none;
  }
`;

export const SponsorImage = styled.img`
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 4px;
  width: 80px;
  height: 38px;
  background-color: white;
  border-radius: 5px;
`;

export const ChallengeInfo = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 150px);
  justify-content: space-between;
`;

export const ChallengeInfoHeader = styled.div`
  display: content;
`;

export const ChallengeDetails = styled.div`
  font-size: 12px;
`;

export const ChallengeNameAndCategory = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ChallengeDetailsAndTestTag = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DetailsLabel = styled.label`
  font-weight: 600;
  margin-bottom: 0;
`;

export const DetailsContainer = styled.div``;

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 10px;
`;

export const ChallengeCategory = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
  color: ${colors.darkBlue};
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: pre;
`;

export const ChallengeName = styled.span`
  font-size: 14px;
  padding-bottom: 6px !important;
  color: ${colors.darkBlue};
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: pre;
  width: 70%;
`;

export const ChallengeDescription = styled.div`
  font-size: 11px;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const SelectedCheckbox = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  color: #295c88;
`;

export const CompletionContainer = styled.div`
  font-size: 11px;
  margin-top: 5px;
  text-align: right;
`;
